import {Type} from "ol/geom/Geometry";
import VectorSource from "ol/source/Vector";
import {L} from "../../../lt-ng/landcare-toolkit";
import {_F} from "../../../utility/func";
import Feature from "ol/Feature";
import Item = L.tree.Item;
import {Geometry} from "ol/geom";

const ofTypes = (gts: Type[]) => (f: Feature<Geometry>) => {
    return gts.some(gt => f.getGeometry().getType() === gt);
}
const isPoly = ofTypes(['Polygon', 'MultiPolygon']);
const isPoint = ofTypes(['Point', 'MultiPoint']);
const isLine = ofTypes(['LineString', 'MultiLineString']);

function lineLegendChip(w: number, h: number, colour: string, canvas: HTMLCanvasElement = null, border: string = null, lineWidth = 1): string {
    canvas = canvas || document.createElement('canvas');

    canvas.width = w;
    canvas.height = h;

    let ctx = canvas.getContext("2d");

    ctx.rect(0, 0, w, h);
    ctx.fillStyle = colour;
    ctx.fill();

    if (border) {
        ctx.strokeStyle = border;
        ctx.lineWidth = lineWidth;
        ctx.strokeRect(0, 0, w, h);
    }

    return canvas.toDataURL();
}

function pointLegendChip(w: number, h: number, colour: string, canvas: HTMLCanvasElement = null, border: string = null, lineWidth = 2): string {
    canvas = canvas || document.createElement('canvas');

    canvas.width = w;
    canvas.height = h;

    let ctx = canvas.getContext("2d");

    ctx.rect(0, 0, w, h);
    ctx.fillStyle = colour;
    ctx.fill();

    if (border) {
        ctx.strokeStyle = border;
        ctx.lineWidth = lineWidth;
        ctx.arc(w / 2, h / 2, Math.min(w, h) / 2 - lineWidth * 2, 0, 360);
    }

    return canvas.toDataURL();
}

export function generateLegendItems(source: VectorSource<Geometry>, styleDefinition: Partial<Record<Type, any>>, id, parent: Item): Item[] {
    const polyStyle = styleDefinition['Polygon'];
    const pointStyle = styleDefinition['Point'];
    const lineStyle = styleDefinition['LineString'];

    function item(name: string, id: number, visible: boolean, iconUrl: string = undefined) {
        const icon = document.createElement('img');
        icon.src = iconUrl;
        icon.alt = name;

        return {
            classId: id,
            index: id,
            name: name,
            isChecked: () => true,
            click: (node) => {
                L.tree.clickItem(node);
            },
            selected: parent.selected,
            extraCSSClasses: visible ? "class-no-layer" : 'class-no-layer hidden',
            icon: visible ? icon.outerHTML : undefined,
            iconUrl: visible ? iconUrl : undefined,
            parent,
            rootItems: [],
            extraState: {
                metaLayerSelector: {
                    get checked() {
                        return parent.extraState.metaLayerSelector.checked
                    },
                    set checked(isChecked) {
                    },
                    expanded: false
                }
            }
        }
    }

    const hasPolys = source.getFeatures().some(isPoly);
    const hasPoints = source.getFeatures().some(isPoint);
    const hasLines = source.getFeatures().some(isLine);

    return [
        item('Polygons', id, hasPolys, _F.colourToLegendChip(40, 30, polyStyle.fill.color, null, polyStyle.stroke.color, 3)),
        item('Points', id + 1, hasPoints,  _F.colourToLegendChip(40, 30, pointStyle.image.fill.color, null, pointStyle.image.stroke.color, 3)),
        item('Lines', id + 2, hasLines, lineLegendChip(40, 30, lineStyle.stroke.color, null, lineStyle.stroke.color))
    ];
}